import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { MainTable, BackButton, CompleteButton } from 'components/ERP';
import excelIcon from 'assets/images/icon_excel.png';
import { ExcelRenderer } from 'react-excel-renderer';
import { Button, Upload } from 'antd';
import Swal from 'sweetalert2';
import {
  createItemgroups,
  updateItemGroups,
  getItemGroups,
  getBrandData,
  updateItemgroupsImage,
} from 'http-api';
import { useSelector } from 'react-redux';

export default function ERP() {
  const user = useSelector((state) => state.user);
  const [rows, setRows] = useState([]);
  const isErpData = false;
  const [brandData, setBrandData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendData, setSendData] = useState([]);
  const [sendLoading, setSendLoading] = useState();

  const createErpData = async (row) => {
    const data = {
      messageType: 'create',
      groupId: 1,
      erpDatas: row,
    };
    setLoading(true);

    console.log(user.token);
    console.log(data);

    const response = await createItemgroups(user.token, data);
    console.log(response);
    if (row.length !== 0) {
      if (response.data.code === 201) {
        console.log('create', response);
        getErpData();
      }
    }
  };
  const updateErpData = async (row) => {
    const data = {
      messageType: 'update',
      groupId: 1,
      erpDatas: row,
    };
    setLoading(true);

    const response = await updateItemGroups(user.token, data);
    console.log(response);
    if (row.length !== 0) {
      if (response.data.code === 201) {
        console.log('update', response);
        getErpData();
      }
    }
  };

  const getErpData = async () => {
    setLoading(true);
    try {
      const response = await getItemGroups(user.token);
      console.log(response);
      if (response.data.result.length !== 0) {
        setRows(response.data.result);
      } else {
        Swal.fire({
          title: 'Excel 파일을 등록 해주세요',
          showCancelButton: true,
          confirmButtonText: '확인',
          cancelButtonText: '취소',
        }).then((result) => {
          if (result.isConfirmed) {
            document.getElementById('upload').click();
          }
        });
      }
    } catch (err) {
      alert('데이터를 불러올 수 없습니다.');
    } finally {
      setLoading(false);
    }
  };
  const getBrandDatas = async () => {
    const response = await getBrandData(user.token);
    setBrandData(response.data.result);
  };
  useEffect(() => {
    if (user.token) {
      getErpData();
      getBrandDatas();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const uploadExcel = () => {
    Swal.fire({
      title: 'Excel 파일을 등록 하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        document.getElementById('upload').click();
      }
    });
  };
  const complete = async () => {
    const data = {
      groupId: 1,
      data: sendData,
    };
    setSendLoading(true);
    await updateItemgroupsImage(user.token, data);
    enterLoading();
  };
  const enterLoading = () => {
    setSendLoading(false);
    Swal.fire({
      title: '수정 완료',
      text: '다른 아이템을 수정하시겠습니까?',
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      } else {
        window.location.href = '/registitem';
      }
    });
  };

  const fileHandler = (fileList) => {
    let fileObj = fileList;
    if (!fileObj) {
      alert('파일이 업로드되지 않았습니다.');
      return false;
    }
    //just pass the fileObj as parameter
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        console.log(err);
      } else {
        let newRows = [];
        resp.rows.slice(2, -1).map((row, index) => {
          if (row && row !== 'undefined') {
            newRows.push({
              key: index,
              code: row[0],
              name: row[1],
              type: row[2],
              size: row[3],
              brandName: row[4],
              brandCode: row[5],
              itemGroupName: row[6],
              itemGroupCode: row[7],
              representativeName: row[8],
              representativeCode: row[9],
              search: row[10],
              use: row[11],
            });
          }
          return newRows;
        });
        if (newRows.length === 0) {
          return false;
        } else {
          isErpData ? updateErpData(newRows) : createErpData(newRows);
        }
      }
    });
    return false;
  };

  return (
    <Container>
      <Wrapper>
        <SubTitle>ERP 등록제품 이미지 등록(및 수정)</SubTitle>
        <br />
        <Description>
          이미지 항목에 있는 사각형을 누르면 제품 사진을 등록 및 수정 할 수
          있습니다.
        </Description>
        {/* <ImportExcelButton text="엑셀 파일 등록" fileHandler={fileHandler} /> */}
        <ExcelButtonWrapper>
          <ExcelButton onClick={() => uploadExcel()}>
            <ExcelIcon src={excelIcon} alt="엑셀아이콘" />
            엑셀 파일 등록
          </ExcelButton>
          <Upload
            name="file"
            id="upload"
            accept=".xlsx, .xls"
            beforeUpload={fileHandler}
            onRemove={() => setRows([])}
            multiple={false}
          >
            <button style={{ display: 'none' }}></button>
          </Upload>
        </ExcelButtonWrapper>
        <MainTable
          data={rows}
          loading={loading}
          sendData={sendData}
          setSendData={setSendData}
          brandData={brandData || []}
        />
        <FlexBox>
          <BackButton />
          <CompleteButton
            text="완료"
            complete={complete}
            sendLoading={sendLoading}
          />
        </FlexBox>
      </Wrapper>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 56px);
  text-align: center;
  /* z-index: -1; */
`;
const Wrapper = styled.div`
  position: relative;
  top: 100px;
  display: inline-block;
  width: 60%;
  text-align: start;
  padding-bottom: 40px;
`;
const SubTitle = styled.h2`
  position: relative;
  display: inline-block;
`;
const Description = styled.div`
  position: relative;
  display: inline-block;
  color: ${(props) => props.theme.colors.darkGray};
`;
const FlexBox = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
`;
const ExcelButtonWrapper = styled.div`
  float: right;
  .ant-upload-list {
    display: none;
  }
`;
const ExcelButton = styled(Button)`
  all: unset;
  border: 1px solid ${(props) => props.theme.colors.gray};
  color: #000;
  background-color: #fff;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  text-decoration: none;
  transition: 0.2s all;
  line-height: 23px;

  &:active {
    transform: translateY(3px);
  }
`;
const ExcelIcon = styled.img`
  margin-right: 10px;
`;
